























































































import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import ThemeImg from "@/components/ThemeImg.vue";
import Vue from "vue";
import { SourceConnection } from "../../data/model";
export default Vue.extend({
  components: {
    ThemeImg,
  },
  props: ["connections"],
  setup(_, { emit }) {
    const show_active_sessions = (connection: SourceConnection) => {
      console.log("show_active_sessions", connection);
      emit("show_sessions", {
        connection,
        session_is_active: true,
      });
    };

    const show_closed_sessions = (connection: SourceConnection) => {
      console.log("show_closed_sessions", connection);
      emit("show_sessions", {
        connection,
        session_is_active: false,
      });
    };

    const show_connection_menu = async (
      connection: SourceConnection,
      event: MouseEvent
    ) => {
      console.log("show_connection_menu", connection);
      const res = await UseDrillDownMenu().show({
        event,
        menu: [
          {
            disable: false,
            isCategory: false,
            isPremium: false,
            name: "Start Session",
            subItems: [],
            action: "start-session",
          },
          {
            disable: false,
            isCategory: false,
            isPremium: false,
            name: "Remove Connection",
            subItems: [],
            action: "remove-connection",
          },
        ],
      });
      if (res.didUserSelectedAnAction) {
        switch (res.actionSelected) {
          case "start-session":
            //    show_active_sessions(connection);
            emit("start_session", connection);
            break;
          case "remove-connection":
            emit("remove", connection);
            break;
        }
      }
    };

    return { show_active_sessions, show_closed_sessions, show_connection_menu };
  },
});
